/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three';
import React, { useMemo, useState } from 'react'

import DoorModel from '../../../DoorWindows/DoorModel';
import WindowModel from '../../../DoorWindows/WindowModel';
import { GlassTextureImg } from '../../../../../utils/Textures';
import { const_var } from '../../../../../redux/reducers/reducer';
import { wallnameBySec } from '../../../../../redux/reducers/componentReducer';

const DoorWindows = ({ overlapTrussArr, setOverlapTrussArr }) => {
    const [isMapLoad, setIsMapLoad] = useState(false);
    const [overlapDoorArr, setOverlapDoorArr] = useState([]);

    const glassTexture = useMemo(() => {
        let texture = null;

        if (isMapLoad === false) {
            texture = new THREE.CubeTextureLoader().load([process.env.REACT_APP_BASE_URL+GlassTextureImg, process.env.REACT_APP_BASE_URL+GlassTextureImg, process.env.REACT_APP_BASE_URL+GlassTextureImg, process.env.REACT_APP_BASE_URL+GlassTextureImg, process.env.REACT_APP_BASE_URL+GlassTextureImg, process.env.REACT_APP_BASE_URL+GlassTextureImg])

            setIsMapLoad(true);
        }

        return texture;
    }, []);

    const doorParams = {
        id: 0,
        compName: "temp-door",
        width: 5,
        height: 6,

        trimWidth: 0.1,
        doorColor: '#ffffff',
        overlapTrimColor: "#ff0000",
        glassTexture: glassTexture,
    }

    return (
        <>
            {const_var.newDoorsArray.map((item, index) =>
            wallnameBySec[item.userData.wallName] === 'rightlean' && (
                <group key={item.uniqueId} name={`door_model_on_${item.userData.wallName}`}>
                    {(item.userData.compType === "garage_door" || item.userData.compType === "garage_door_frameout" || item.userData.compType === "walkin" || item.userData.compType === "walkin_frameout") && (
                        <DoorModel
                            id={item.uniqueId}
                            wallName={item.userData.wallName}
                            compName={item.userData.compName}
                            compType={item.userData.compType}
                            width={item.width}
                            height={item.height}
                            defaultPositionX={item.positionX}
                            defaultPositionY={item.positionY}
                            trimWidth={doorParams.trimWidth}
                            doorColor={(item!=undefined && item.doorColor!=undefined)?item.doorColor:doorParams.doorColor}
                            overlapTrimColor={doorParams.overlapTrimColor}
                            glassTexture={doorParams.glassTexture}
                            overlapDoorArr={overlapDoorArr}
                            setOverlapDoorArr={setOverlapDoorArr}
                            overlapTrussArr={overlapTrussArr}
                            setOverlapTrussArr={setOverlapTrussArr}
                        />
                    )}
                    {(item.userData.compType === "window" || item.userData.compType === "window_frameout") && (
                        <WindowModel
                            id={item.uniqueId}
                            wallName={item.userData.wallName}
                            compName={item.userData.compName}
                            compType={item.userData.compType}
                            width={item.width}
                            height={item.height}
                            defaultPositionX={item.positionX}
                            defaultPositionY={item.positionY}
                            trimWidth={doorParams.trimWidth}
                            doorColor={doorParams.doorColor}
                            overlapTrimColor={doorParams.overlapTrimColor}
                            glassTexture={doorParams.glassTexture}
                            overlapDoorArr={overlapDoorArr}
                            setOverlapDoorArr={setOverlapDoorArr}
                            overlapTrussArr={overlapTrussArr}
                            setOverlapTrussArr={setOverlapTrussArr}
                        />
                    )}
                </group>
            ))}
        </>
    )
}

export default DoorWindows